import React from 'react'
import BarcodeInitialize from '../BarcodeInitialize'

import BarcodeRoutes from './Routes'
import BarcodeHeader from '../BarcodeHeader'
import BarcodeToastMessage from '../BarcodeToastMessage'

function BarcodeMain() {
  return (
    <BarcodeInitialize>
      <BarcodeToastMessage />
      <BarcodeHeader />
      <BarcodeRoutes />
    </BarcodeInitialize>
  )
}

export default BarcodeMain
